import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=dc270bf2&scoped=true"
import script from "./infomation.vue?vue&type=script&lang=js"
export * from "./infomation.vue?vue&type=script&lang=js"
import style0 from "./infomation.vue?vue&type=style&index=0&id=dc270bf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc270bf2",
  null
  
)

export default component.exports